import { useEffect } from 'react';

const useClickOutsideHook = <T extends HTMLElement>({
  ref,
  clickOutside,
}: {
  ref?: React.RefObject<T | null> | null;
  clickOutside?: (isClickOutside: boolean) => void;
}) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref?.current && !ref?.current.contains(event.target as Node)) {
        clickOutside?.(true);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
};

export default useClickOutsideHook;
